import axios from 'axios';
import { CLIENT_REST_ROUTE } from '../routes/constants';
import { logError } from './utils';

const getUrlPath = () => CLIENT_REST_ROUTE.SELLER_PAGE_DATA;

/** @type {import('./getSellerPageData').GetSellerPageData} */
export const getSellerPageData = (username) =>
    axios
        .post(getUrlPath(), { username })
        .then(({ data }) => data)
        .catch((error) => {
            logError('Failed to fetch seller data', { error });
            throw error;
        });
